import { useEffect, useState, useRef } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import API, { getAuthConfig } from "../services/api";
import { useNavigate } from "react-router-dom";

function Scan() {
  const navigate = useNavigate();
  const [action, setAction] = useState("checkin");
  const isProcessing = useRef(false);

  useEffect(() =>{
    const scanner = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 250 });

    scanner.render(
      async (decodedText) =>{
        if(isProcessing.current) return;
        isProcessing.current = true;

        try{
          const res = await API.post(
            "/check/scan",
            { visitorId: decodedText, action},
            getAuthConfig());

          alert(res.data.message);
          await scanner.clear();
          isProcessing.current = false;
        } 
        catch(err){
          alert(err.response?.data?.message || "Scan failed");
          isProcessing.current = false;
        }
      },
      () => {}
    );

    return() =>{
      scanner.clear().catch(() => {});
      isProcessing.current = false;
    };
  }, [action]);

  return(
    <div className="p-8 flex flex-col items-center bg-gray-50 min-h-screen">
      <h2 className="text-2xl font-bold mb-4">Security QR Scanner</h2>

      <div className="flex gap-4 mb-6">
        <button
          onClick={() => {
            setAction("checkin");
            isProcessing.current = false;
          }}
          className={`px-6 py-2 rounded-lg font-bold ${action === "checkin" ? "bg-green-600 text-white" : "bg-gray-200"}`}>
          Check-In Mode
        </button>

        <button
          onClick={() => {
            setAction("checkout");
            isProcessing.current = false;
          }}
          className={`px-6 py-2 rounded-lg font-bold ${action === "checkout" ? "bg-orange-600 text-white" : "bg-gray-200"}`}>
          Check-Out Mode
        </button>

      </div>

      <div
        id="reader"
        className="border-4 border-white rounded-xl shadow-lg"
        style={{ width: "400px" }}>
      </div>

      <button
        onClick={() => navigate("/dashboard")}
        className="mt-8 text-blue-600 font-medium hover:underline">
        Back to Dashboard
      </button>
      
    </div>
  );
}

export default Scan;
